import { create } from "zustand";

interface exModalState {
  isOpen: boolean;
  setIsOpen: (value: boolean) => void;
}

const useExStore = create<exModalState>((set) => ({
  isOpen: false,
  setIsOpen: (value) => set({ isOpen: value }),
}));

export default useExStore;
